import React from 'react';
import PropTypes from 'prop-types';
import CheckBoxAttribute from '../../../CheckBoxAttribute';
import { HOST_SET_ROUTE } from '../../../../../utils/constants';
import { ERROR_TEXT_NO_THANK_YOU_URL } from '../../../../../langs/en/errors';

const ThankYouRouteRow = ({ error, label, keyPath, options = {}, onHostRouteChange, setThankYouRoute, fieldValidityChanged, values }) => {
  const errorMessage = error[label] && error[label].error && error[label].error.text;
  return (
    <div className="form-row mb-2">
      <div className="d-flex align-items-center ml-2">
        <div style={{ height: '20px' }}>
          <CheckBoxAttribute
            keyPath={[...keyPath, HOST_SET_ROUTE]}
            value={options[label] !== HOST_SET_ROUTE}
            onCheckBoxChange={(e, value) => onHostRouteChange(value, label)}
          />
        </div>
      </div>
      <span className="d-flex align-items-center">
        <label className="code mb-0 mr-1">{label}</label> redirects to
      </span>
      <div className={`flex-grow-1 w-auto ml-2 ${errorMessage ? 'border-input-error' : ''}`}>
        <input
          className="form-control"
          type="text"
          placeholder={options[label] === HOST_SET_ROUTE ? 'host set route' : ''}
          value={options[label] === HOST_SET_ROUTE ? '' : options[label]}
          disabled={options[label] === HOST_SET_ROUTE}
          onChange={(e) => {
            setThankYouRoute(values.id, label, e.target.value);
            if (!e.target.value.length) {
              fieldValidityChanged([...keyPath, label], false, ERROR_TEXT_NO_THANK_YOU_URL);
            } else {
              fieldValidityChanged([...keyPath, label], true);
            }
          }}
        />
        <div className="invalid-feedback mt-2 d-block">
          {errorMessage}
        </div>
      </div>
    </div>
  );
};

ThankYouRouteRow.propTypes = {
  onHostRouteChange: PropTypes.func.isRequired,
  values: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    editors: PropTypes.object.isRequired,
  }).isRequired,
  error: PropTypes.object.isRequired,
  keyPath: PropTypes.array.isRequired,
  options: PropTypes.object,
  setThankYouRoute: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  fieldValidityChanged: PropTypes.func.isRequired,
};

export default ThankYouRouteRow;
